import { EditPencilIcon } from '@/shared/assets'
import { Button2 } from '@/true-fsd/shared/ui/ButtonLink'
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogOverlay,
    DialogPortal,
    DialogTitle,
    DialogTrigger,
} from '@radix-ui/react-dialog'
import { default as cl, default as clsx } from 'clsx'
import { useCallback, useState } from 'react'
import { LinkEditor, type LinkEditorProps } from './LinkEditor'
import classes from './UTMLinkEditDialog.module.scss'

export type UTMLinkEditDialogProps = {
    disabled: boolean
} & Omit<LinkEditorProps, 'RenderButtons' | 'onSuccess'>

const RenderButtons: LinkEditorProps['RenderButtons'] = ({
    disabled,
    onSave,
}) => (
    <div className={classes.buttons}>
        <DialogClose asChild>
            <Button2 className={cl(classes.button, classes.cancel)}>
                Отмена
            </Button2>
        </DialogClose>
        <Button2
            className={cl(classes.button, classes.apply)}
            disabled={disabled}
            onClick={onSave}
        >
            Сохранить
        </Button2>
    </div>
)

export const UTMLinkEditDialog = ({
    utmLink,
    disabled,
    groupId,
    activeSite,
    siteLink,
    erid,
}: UTMLinkEditDialogProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const onSuccess = useCallback(() => {
        setIsOpen(false)
    }, [])

    if (disabled) {
        return (
            <EditPencilIcon
                className={clsx('h-[18px] w-auto flex-shrink-0', 'invisible')}
            />
        )
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                <EditPencilIcon
                    className={clsx('h-[18px] w-auto flex-shrink-0')}
                />
            </DialogTrigger>
            <DialogPortal>
                <DialogOverlay className={classes.overlay}>
                    {isOpen && (
                        <DialogContent
                            aria-describedby={undefined}
                            className={classes.content}
                        >
                            <DialogTitle className={classes.title}>
                                Настройки параметров UTM-ссылки
                            </DialogTitle>
                            <LinkEditor
                                {...{
                                    groupId,
                                    activeSite,
                                    siteLink,
                                    utmLink,
                                    onSuccess,
                                    erid,
                                    RenderButtons,
                                }}
                            />
                        </DialogContent>
                    )}
                </DialogOverlay>
            </DialogPortal>
        </Dialog>
    )
}
